import React, { useEffect } from 'react';
import GallaryComp from "../Gallary_component/GallaryComp.js";
import HeroContent from '../Hero_component/Hero.js';

function Gallary() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component loads
  }, []);
    return (
      <>
      <HeroContent title ="Gallery" image={require('../../resource/Banner/header.jpg')}/>
      <GallaryComp />
      </>
    );
  }
  
  export default Gallary;